import { formatNumber, persianDigits } from "@/features/reports/lib/format";
import { persianDisplayText } from "@/lib/persianUi";
import { fa } from "../i18n/fa";

const cellColor = (value, maximum) => {
  if (!value || !maximum) return "var(--gray-bg)";
  const alpha = 0.18 + 0.82 * Math.sqrt(Math.max(0, value) / maximum);
  return `rgba(0, 105, 92, ${alpha})`;
};

export default function GeoHeatmap({ data, hideEmpty, onSelect }) {
  const maximum = Math.max(0, ...data.rows.flatMap((row) => row.values));
  const rows = data.rows
    .filter((row) => !hideEmpty || row.values.some((value) => value > 0))
    .sort((left, right) => {
      if (left.code === "unassigned") return 1;
      if (right.code === "unassigned") return -1;
      return right.values.reduce((sum, value) => sum + value, 0)
        - left.values.reduce((sum, value) => sum + value, 0);
    });
  const columns = `200px repeat(${data.periods.length}, minmax(54px, 1fr))`;

  if (!data.periods.length) return <div className="tr-empty"><p>{fa.geo.noRecords}</p></div>;

  return (
    <div className="tr-geo-heatmap-scroll">
      <div
        className="tr-geo-heatmap"
        style={{ gridTemplateColumns: columns }}
        role="grid"
        aria-label={fa.geo.heatmapTitle}
      >
        <div className="tr-geo-heatmap-head" role="columnheader">{fa.geo.province}</div>
        {data.periods.map((period) => (
          <div className="tr-geo-heatmap-head" role="columnheader" key={period.start}>
            {persianDigits(period.label)}
          </div>
        ))}
        {rows.map((row) => (
          <div className="tr-geo-heatmap-row" role="row" key={row.code} style={{ display: "contents" }}>
            <button
              type="button"
              className="tr-geo-heatmap-name"
              role="gridcell"
              onClick={() => onSelect(row.code === "unassigned" ? "unassigned" : row.code)}
            >
              {persianDisplayText(row.name, 'نامشخص')}
            </button>
            {row.values.map((value, index) => (
              <div
                className="tr-geo-heatmap-cell"
                key={`${row.code}-${data.periods[index].start}`}
                role="gridcell"
                style={{ backgroundColor: cellColor(value, maximum) }}
                title={`${persianDisplayText(row.name, 'نامشخص')} · ${persianDigits(data.periods[index].label)}: ${fa.geo.kg(value)}`}
                aria-label={`${persianDisplayText(row.name, 'نامشخص')}، ${persianDigits(data.periods[index].label)}، ${fa.geo.kg(value)}`}
              >
                {value ? formatNumber(value) : "—"}
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="tr-geo-legend">
        <span>{fa.geo.low(formatNumber(0))}</span>
        <span className="tr-geo-legend-scale" />
        <span>{fa.geo.high(formatNumber(maximum))}</span>
      </div>
    </div>
  );
}
